let rule = [
  {
    path: '/integralRule',
    name: 'integralRule',
    component: () => import('@/pages/rulePages/integralRule/index.vue'),
    meta: {
      title: '积分规则'
    }
  },
  {
    path: '/integralRule2',
    name: 'integralRule2',
    component: () => import('@/pages/rulePages/integralRule2/index.vue'),
    meta: {
      title: '积分规则'
    }
  },
  {
    path: '/integralRule3',
    name: 'integralRule3',
    component: () => import('@/pages/rulePages/integralRule3/index.vue'),
    meta: {
      title: '积分规则'
    }
  },
  {
    path: '/integralRule4',
    name: 'integralRule4',
    component: () => import('@/pages/rulePages/integralRule4/index.vue'),
    meta: {
      title: '积分规则'
    }
  },
   // 对照组
  //  {
  //   path: '/giftBoxB',
  //   name: 'giftBoxB',
  //   component: () => import('@/pages/rulePages/giftBoxB/index.vue'),
  //   meta: {
  //     title: '玩法规则'
  //   }
  // },
  // 实验组
  // {
  //   path: '/giftBoxBtest',
  //   name: 'giftBoxBtest',
  //   component: () => import('@/pages/rulePages/giftBoxB/test.vue'),
  //   meta: {
  //     title: '玩法规则'
  //   }
  // },
  // {
  //   path: '/giftBoxC',
  //   name: 'giftBoxC',
  //   component: () => import('@/pages/rulePages/giftBoxC/index.vue'),
  //   meta: {
  //     title: '玩法规则'
  //   }
  // },
  {
    path: '/punishRule',
    name: 'punishRule',
    component: () => import('@/pages/rulePages/punishRule/index.vue'),
    meta: {
      title: '惩罚规则'
    }
  },
  {
    path: '/khRuleB',
    name: 'khRuleB',
    component: () => import('@/pages/rulePages/khRule/indexB.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/newKhRuleB',
    name: 'newKhRuleB',
    component: () => import('@/pages/rulePages/khRule/newIndexB.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/khRuleC',
    name: 'khRuleC',
    component: () => import('@/pages/rulePages/khRule/indexC.vue'),
    meta: {
      title: '开黑奖励规则'
    }
  },
  {
    path: '/leaderRewardRule',
    name: 'leaderRewardRule',
    component: () => import('@/pages/rulePages/leaderRewardRule/index.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/talkPage',
    name: 'talkPage',
    component: () => import('@/pages/rulePages/talkPage/index.vue'),
    meta: {
      title: '谈天说地规则'
    }
  },
  {
    path: '/leaderDialog',
    name: 'leaderDialog',
    component: () => import('@/pages/rulePages/leaderDialog/index.vue'),
    meta: {
      title: '领队积分规则'
    }
  },
  {
    path: '/newLeaderDialog',
    name: 'newLeaderDialog',
    component: () => import('@/pages/rulePages/leaderDialog/newIndex.vue'),
    meta: {
      title: '领队积分规则'
    }
  },
  {
    path: '/cardiacRules',
    name: 'cardiacRules',
    component: () => import('@/pages/rulePages/cardiacRules/index.vue'),
    meta: {
      title: '心动问答规则'
    }
  },
  {
    path: '/ktvLeaderDialog',
    name: 'ktvLeaderDialog',
    component: () => import('@/pages/rulePages/ktvLeaderDialog/index.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/newKtvLeaderDialog',
    name: 'newKtvLeaderDialog',
    component: () => import('@/pages/rulePages/ktvLeaderDialog/newIndex.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/ktvRule',
    name: 'ktvRule',
    component: () => import('@/pages/rulePages/ktvRule/index.vue'),
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/spyRule',
    name: 'spyRule',
    component: () => import('@/pages/rulePages/spyRule/index.vue'),
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/spyLeaderDialog',
    name: 'spyLeaderDialog',
    component: () => import('@/pages/rulePages/spyLeaderDialog/index.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/newSpyLeaderDialog',
    name: 'newSpyLeaderDialog',
    component: () => import('@/pages/rulePages/spyLeaderDialog/newIndex.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/xiaoJiuGuanLeaderDialog',
    name: 'xiaoJiuGuanLeaderDialog',
    component: () => import('@/pages/rulePages/xiaoJiuGuanLeaderDialog/index.vue'),
    meta: {
      title: '领队积分规则'
    }
  },
  {
    path: '/newXiaoJiuGuanLeaderDialog',
    name: 'newXiaoJiuGuanLeaderDialog',
    component: () => import('@/pages/rulePages/xiaoJiuGuanLeaderDialog/newIndex.vue'),
    meta: {
      title: '领队积分规则'
    }
  },
  {
    path: '/xiaoJiuGuanRule',
    name: 'xiaoJiuGuanRule',
    component: () => import('@/pages/rulePages/xiaoJiuGuanRule/index.vue'),
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/honorOfKingsRule',
    name: 'honorOfKingsRule',
    component: () => import('@/pages/rulePages/honorOfKingsRule/index.vue'),
    meta: {
      title: '领队奖励规则'
    }
  },
  {
    path: '/playExplain',
    name: 'playExplain',
    component: () => import('@/pages/rulePages/playExplain/index.vue'),
    meta: {
      title: '玩法说明'
    }
  },
  {
    path: '/starReduce',
    name: 'starReduce',
    component: () => import('@/pages/rulePages/kpiRuleBox/starReduce.vue'),
    meta: {
      title: '星星扣减规则'
    }
  },
  {
    path: '/starBindCp',
    name: 'starBindCp',
    component: () => import('@/pages/rulePages/kpiRuleBox/starBindCp.vue'),
    meta: {
      title: '星星分和组CP率得分说明'
    }
  },
  {
    path: '/addFamilyScore',
    name: 'addFamilyScore',
    component: () => import('@/pages/rulePages/kpiRuleBox/addFamilyScore.vue'),
    meta: {
      title: '如何提升家族分'
    }
  },
  {
    path: '/reduce',
    name: 'reduce',
    component: () => import('@/pages/rulePages/kpiRuleBox/reduce.vue'),
    meta: {
      title: '扣减规则'
    }
  },
  {
    path: '/micGetStar',
    name: 'micGetStar',
    component: () => import('@/pages/rulePages/micGetStar/index.vue'),
    meta: {
      title: '上麦领星星规则'
    }
  },
  {
    path: '/gameStar',
    name: 'gameStar',
    component: () => import('@/pages/rulePages/gameStar/index.vue'),
    meta: {
      title: '玩游戏得星星规则'
    }
  },
  {
    path: '/part_rule',
    name: 'part_rule',
    component: () => import('@/pages/rulePages/partRule/index.vue'),
    meta: {
      title: '生日派对活动规则'
    }
  },
  {
    path: '/maitian_task_rule',
    name: 'maitian_task_rule',
    component: () => import('@/pages/rulePages/maitianTaskRule/index.vue'),
    meta: {
      title: '任务规则'
    }
  }
]

export {
  rule
}